export enum PlatformPerfMetric {
  AppInit = 'app_init',
  AppRendered = 'app_rendered',
  WebBridgeCall = 'web_bridge_call',
}

export enum BusinessPerfMetric {
  PageLoad = 'page_load',
  GTMEventReport = 'gtm_event_report',
  // One Credential Delink
  OneCredentialDelinkInit = 'one_credential_delink_init',
  OneCredentialDelinkErrorPage = 'one_credential_delink_error_page',
  OneCredentialDelinkCommit = 'one_credential_delink_commit',
  // Third Party Account
  ThirdPartyAccountAttemptLogin = 'third_party_account_attempt_login', // login onclick
  ThirdPartyAccountLogin = 'third_party_account_login', // login success or fail
  ThirdPartyAccountAttemptLink = 'third_party_account_attempt_link', // link onclick
  ThirdPartyAccountLinkOrUnlink = 'third_party_account_link_or_unlink', // link or unlink success or fail
  // IVS
  NeedIvsLoginTriggered = 'ivs_login_triggered',
  LoginByIvsSuccess = 'login_by_ivs_success',
  LoginByIvsFailed = 'login_by_ivs_failed',
  // Login By Password
  SubmitPassword = 'submit_password',
  LoginByPasswordResult = 'login_by_password_result',
}

export enum BusinessFlow {
  SignupByOtp = 'signup_by_otp',
  LoginByPassword = 'login_by_password',
}
